import React from 'react';
import PropTypes from 'prop-types';
import MuiGrid from '@mui/material/Grid';

const breakpointProps = ['xs', 'sm', 'md', 'lg', 'xl'];

const Grid = React.forwardRef(
  ({ item = false, zeroMinWidth = false, justify = undefined, justifyContent = undefined, size = undefined, sx = undefined, xs = undefined, sm = undefined, md = undefined, lg = undefined, xl = undefined, ...otherProps }, ref) => {
    const breakpointSizes = size && typeof size === 'object' ? size : { xs, sm, md, lg, xl };
    const responsiveSize = breakpointProps.reduce((sizes, breakpoint) => {
      if (breakpointSizes[breakpoint] !== undefined) {
        sizes[breakpoint] = breakpointSizes[breakpoint];
      }
      return sizes;
    }, {});
    const resolvedXs = size !== undefined && typeof size !== 'object' ? size : responsiveSize.xs;
    const gridSx = zeroMinWidth ? [{ minWidth: 0 }, ...(Array.isArray(sx) ? sx : [sx])] : sx;
    const shouldForwardZeroMinWidth = item && zeroMinWidth;

    return (
      <MuiGrid
        ref={ref}
        item={item}
        {...(shouldForwardZeroMinWidth ? { zeroMinWidth: true } : {})}
        xs={resolvedXs}
        sm={responsiveSize.sm}
        md={responsiveSize.md}
        lg={responsiveSize.lg}
        xl={responsiveSize.xl}
        justifyContent={justifyContent || justify}
        sx={gridSx}
        {...otherProps}
      />
    );
  }
);

Grid.displayName = 'Grid';

Grid.propTypes = {
  item: PropTypes.bool,
  zeroMinWidth: PropTypes.bool,
  justify: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  justifyContent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object, PropTypes.bool]),
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]),
  xs: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  sm: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  md: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  lg: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  xl: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
};

export default Grid;
